import MuiSkeleton, { SkeletonProps as MuiSkeletonProps } from "@mui/material/Skeleton";

export type SkeletonProps = MuiSkeletonProps;

const Skeleton: React.FC<SkeletonProps> = (props) => {
  return <MuiSkeleton {...props}>{props.children}</MuiSkeleton>;
};

export default Skeleton;
